function FormValidateRecaptcha() {
  // Seleciona os botoes de submit recaptchas que estão em formularios com jquery validator
  const $recaptchaSubmitBtns = $('form[data-validate] [data-recaptcha-submit]:not(.hidden), form.js-validate [data-recaptcha-submit]:not(.hidden)');

  $recaptchaSubmitBtns.each(function (n, el) {
    const $form = $(el.form);

    // Faz um clone do botao
    const btn = el.cloneNode(true);
    // Altera o tipo para button
    btn.setAttribute('type', 'button');
    // Remove o attributo do google recaptcha
    btn.removeAttribute('data-recaptcha-submit');
    // Adiciona o evento que irá fazer a validação do jquery, e caso
    // obtenha sucesso irá chamar o botão padrao que fará o restante
    // com o google recaptcha
    btn.addEventListener('click', function () {
      if ($form.valid()) {
        el.click();
      }
    })

    // Some com o botão do google recaptcha
    el.classList.add('hidden');

    // Adiciona o novo botão ao lado do botão original
    el.parentElement.insertBefore(btn, el);
  });
}

exports.init = FormValidateRecaptcha;
